import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-e-service-icon/jb-e-service-icon.css.ts
var jb_e_service_icon_css_default = i`:host{font-family:var(--theme-font-regular-family, VerlagSSm, Tahoma, sans-serif);font-weight:var(--theme-font-regular-weight, 400)}:host{font-size:var(--theme-typo-p-mini-highlight-desktop-fontsize, 0.813rem);line-height:var(--theme-typo-p-mini-highlight-desktop-lineheight, 1.25rem)}:host{align-items:center;color:inherit;cursor:pointer;display:var(--icon-display, inline-flex);gap:var(--theme-spacing-3xs)}:host(:hover) #shackle{translate:0 -3px}svg{block-size:24px;inline-size:24px;overflow:visible;padding:2px;translate:0 -2px;z-index:1}#shackle{transition:translate .2s ease-in-out}`;

export {
  jb_e_service_icon_css_default
};
